import _typeof from "@babel/runtime/helpers/esm/typeof";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.search.js";
import { defineComponent as _defineComponent } from 'vue';
import { getActivityChipStyle, getActivityChipText, getMaterialityChipColor } from '~/functions/csrd';
import { EnumIroStatus, EnumIroType, useDeleteIroMutation, useListIrosQuery } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'Iro',
  props: {
    query: null
  },
  emits: ['onResult'],
  setup: function setup(__props, _ref) {
    var expose = _ref.expose,
      emit = _ref.emit;
    var props = __props;
    var headerConfig = {
      id: {
        sortable: true
      },
      name: {},
      type: {},
      activity: {},
      sections: {},
      stakeholders: {},
      likelihood: {},
      severity: {},
      timeHorizon: {}
    };
    var _useNuxtApp = useNuxtApp(),
      $i18n = _useNuxtApp.$i18n;
    var locale = computed(function () {
      return $i18n.locale;
    });
    var getImpactChipConfig = function getImpactChipConfig(item) {
      var configs = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, EnumIroType.PositiveImpact, {
        actual: {
          color: '#00AB66',
          text: locale.value === 'de' ? '+ Tatsächlich' : '+ Actual'
        },
        potential: {
          color: '#33BC85',
          text: locale.value === 'de' ? '+ Möglich' : '+ Potential'
        },
        undefined: {
          color: '#5B7185',
          text: locale.value === 'de' ? '+ Auswirkung' : '+ Impact'
        }
      }), EnumIroType.NegativeImpact, {
        actual: {
          color: '#A4485F',
          text: locale.value === 'de' ? '- Tatsächlich' : '- Actual'
        },
        potential: {
          color: '#B66D7F',
          text: locale.value === 'de' ? '- Möglich' : '- Potential'
        },
        undefined: {
          color: '#5B7185',
          text: locale.value === 'de' ? '- Auswirkung' : '- Impact'
        }
      }), EnumIroType.Risk, {
        color: '#C1B25E',
        text: locale.value === 'de' ? 'Risiko' : 'Risk'
      }), EnumIroType.Opportunity, {
        color: '#3385B1',
        text: locale.value === 'de' ? 'Chance' : 'Opportunity'
      });
      if (item.type === EnumIroType.Risk || item.type === EnumIroType.Opportunity) {
        return configs[item.type];
      }
      if (item.type !== EnumIroType.PositiveImpact && item.type !== EnumIroType.NegativeImpact) {
        return null;
      }
      if (!item.levelOfImpact) {
        return configs[item.type].undefined;
      }
      var normalizedLevel = item.levelOfImpact.toLowerCase();
      return configs[item.type][normalizedLevel];
    };
    var getImpactChipColor = function getImpactChipColor(item) {
      var _getImpactChipConfig$, _getImpactChipConfig;
      return (_getImpactChipConfig$ = (_getImpactChipConfig = getImpactChipConfig(item)) === null || _getImpactChipConfig === void 0 ? void 0 : _getImpactChipConfig.color) !== null && _getImpactChipConfig$ !== void 0 ? _getImpactChipConfig$ : '';
    };
    var getImpactChipTextDisplay = function getImpactChipTextDisplay(item) {
      var _getImpactChipConfig$2, _getImpactChipConfig2;
      return (_getImpactChipConfig$2 = (_getImpactChipConfig2 = getImpactChipConfig(item)) === null || _getImpactChipConfig2 === void 0 ? void 0 : _getImpactChipConfig2.text) !== null && _getImpactChipConfig$2 !== void 0 ? _getImpactChipConfig$2 : '';
    };
    var getActivityType = function getActivityType(item) {
      var _item$activity;
      return (_item$activity = item.activity) === null || _item$activity === void 0 ? void 0 : _item$activity.type;
    };
    var getActivityEditTo = function getActivityEditTo(item) {
      var _item$activity2;
      return ((_item$activity2 = item.activity) === null || _item$activity2 === void 0 ? void 0 : _item$activity2.id) != null ? "/csrd/valueChain/".concat(item.activity.id, "/edit") : '#';
    };
    var getActivityName = function getActivityName(item) {
      var _item$activity$name, _item$activity3;
      return (_item$activity$name = (_item$activity3 = item.activity) === null || _item$activity3 === void 0 ? void 0 : _item$activity3.name) !== null && _item$activity$name !== void 0 ? _item$activity$name : '';
    };
    var scoringMap = {
      1: {
        color: '#698F65',
        text: locale.value === 'de' ? 'Sehr Niedrig' : 'Very Low'
      },
      2: {
        color: '#88C662',
        text: locale.value === 'de' ? 'Niedrig' : 'Low'
      },
      3: {
        color: '#F6CC61',
        text: locale.value === 'de' ? 'Mittel' : 'Medium'
      },
      4: {
        color: '#EE8658',
        text: locale.value === 'de' ? 'Hoch' : 'High'
      },
      5: {
        color: '#DA575E',
        text: locale.value === 'de' ? 'Sehr Hoch' : 'Very High'
      }
    };
    var getScoringColor = function getScoringColor(value) {
      var _scoringMap;
      return (_scoringMap = scoringMap[value | 0]) === null || _scoringMap === void 0 ? void 0 : _scoringMap.color;
    };
    var getScoringText = function getScoringText(value) {
      var _scoringMap2;
      return (_scoringMap2 = scoringMap[value | 0]) === null || _scoringMap2 === void 0 ? void 0 : _scoringMap2.text;
    };
    var route = useRoute();
    var attrs = useAttrs();
    var headers = computed(function () {
      return attrs === null || attrs === void 0 ? void 0 : attrs.headers.map(function (h) {
        return _objectSpread(_objectSpread({
          value: h.value || h
        }, headerConfig[h.value || h]), _typeof(h) === 'object' && h !== null ? h : {});
      });
    });
    var options = ref({
      page: 1,
      itemsPerPage: 10,
      sortDesc: [true]
    });
    var search = ref('');
    var variables = computed(function () {
      return {
        input: _objectSpread(_objectSpread({}, props.query), {}, {
          search: route.query.search || ''
        }),
        offset: options.value.itemsPerPage * (options.value.page - 1),
        limit: options.value.itemsPerPage
      };
    });
    var _useListIrosQuery = useListIrosQuery(variables),
      iroResult = _useListIrosQuery.result,
      iroLoading = _useListIrosQuery.loading,
      refetch = _useListIrosQuery.refetch,
      onResult = _useListIrosQuery.onResult;
    onResult(function (r) {
      return emit('onResult', r);
    });
    expose({
      refetch: refetch
    });
    var items = computed(function () {
      var _iroResult$value;
      return (_iroResult$value = iroResult.value) === null || _iroResult$value === void 0 ? void 0 : _iroResult$value.listIros;
    });
    var itemCount = computed(function () {
      var _iroResult$value2;
      return (iroResult === null || iroResult === void 0 ? void 0 : (_iroResult$value2 = iroResult.value) === null || _iroResult$value2 === void 0 ? void 0 : _iroResult$value2.countIros) || 0;
    });
    var _findEsrsTopicNumber = function findEsrsTopicNumber(section) {
      var _section$label;
      var eNumberRegex = /E\d+/;
      var match = (_section$label = section.label) === null || _section$label === void 0 ? void 0 : _section$label.match(eNumberRegex);
      if (match) {
        return match[0].substring(1); // Remove 'E' and return the number
      }
      if (section.parent) {
        return _findEsrsTopicNumber(section.parent);
      }
      return '';
    };
    var _useDeleteIroMutation = useDeleteIroMutation(),
      deleteIro = _useDeleteIroMutation.mutate,
      loading = _useDeleteIroMutation.loading;
    return {
      __sfc: true,
      headerConfig: headerConfig,
      $i18n: $i18n,
      locale: locale,
      getImpactChipConfig: getImpactChipConfig,
      getImpactChipColor: getImpactChipColor,
      getImpactChipTextDisplay: getImpactChipTextDisplay,
      getActivityType: getActivityType,
      getActivityEditTo: getActivityEditTo,
      getActivityName: getActivityName,
      scoringMap: scoringMap,
      getScoringColor: getScoringColor,
      getScoringText: getScoringText,
      route: route,
      attrs: attrs,
      props: props,
      headers: headers,
      emit: emit,
      options: options,
      search: search,
      variables: variables,
      iroResult: iroResult,
      iroLoading: iroLoading,
      refetch: refetch,
      onResult: onResult,
      items: items,
      itemCount: itemCount,
      findEsrsTopicNumber: _findEsrsTopicNumber,
      deleteIro: deleteIro,
      loading: loading,
      getActivityChipStyle: getActivityChipStyle,
      getActivityChipText: getActivityChipText,
      getMaterialityChipColor: getMaterialityChipColor,
      EnumIroStatus: EnumIroStatus,
      EnumIroType: EnumIroType
    };
  }
});